// extracted by mini-css-extract-plugin
export default {"partnershipsModal":"partnershipsModal_partnershipsModal__2CJw8"};